
import React from 'react';
import CrawlActions from './CrawlActions';
import { type EnhancedCrawlResult } from '@/types/crawler';
import { Globe, Calendar, TrendingUp } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

interface OverviewHeaderProps {
  crawlResult: EnhancedCrawlResult;
  onNewCrawl: () => void;
}

const OverviewHeader: React.FC<OverviewHeaderProps> = ({
  crawlResult,
  onNewCrawl
}) => {
  const analysisDate = new Date();
  const pageCount = crawlResult.pages.length;
  
  return (
    <div className="glass-panel rounded-2xl p-6 bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/10">
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-primary to-primary/80 rounded-xl flex items-center justify-center shadow-lg">
              <TrendingUp className="h-6 w-6 text-primary-foreground" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-foreground">
                <span className="header-gradient fallback-gradient">Analysis Results</span>
              </h1>
              <p className="text-muted-foreground text-sm">Comprehensive website analysis</p>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center gap-4 text-sm">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-background/50 backdrop-blur-sm border border-border/50 max-w-sm lg:max-w-md">
              <Globe className="h-4 w-4 text-primary flex-shrink-0" />
              <span className="font-medium truncate">{crawlResult.url}</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-background/50 backdrop-blur-sm border border-border/50">
              <Calendar className="h-4 w-4 text-muted-foreground" />
              <span>Analyzed {formatDistanceToNow(analysisDate)} ago</span>
            </div>
            <div className="px-3 py-1.5 rounded-full bg-gradient-to-r from-emerald-500/10 to-green-500/10 border border-emerald-500/20">
              <span className="text-emerald-600 dark:text-emerald-400 font-medium">
                {pageCount} page{pageCount !== 1 ? 's' : ''} analyzed
              </span>
            </div>
          </div>
        </div>
        
        <div className="lg:ml-4">
          <CrawlActions 
            onNewCrawl={onNewCrawl}
          />
        </div>
      </div>
    </div>
  );
};

export default OverviewHeader;
